import React from 'react'
import { ReactComponent as KpmgSvg} from '../../assets/svgs/clients/KPMG.svg';

const KpmgLogo = () => (
    <div>
        <KpmgSvg/>
    </div>
)

export default KpmgLogo